import * as React from "react";
import {
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    FormControl,
    InputLabel,
    MenuItem,
    Select,
} from "@mui/material";
import {useTranslation} from "react-i18next";

interface CreatePeriodDialogProps {
    open: boolean;
    onClose: () => void;
    selectedYear: number;
    selectedMonth: number;
    years: number[];
    months: { value: number; label: string }[];
    handleYearChange: (event: any) => void;
    handleMonthChange: (event: any) => void;
    handleCreatePeriod: () => void;
    creatingPeriod: boolean;
}

export default function CreatePeriodDialog({
    open,
    onClose,
    selectedYear,
    selectedMonth,
    years,
    months,
    handleYearChange,
    handleMonthChange,
    handleCreatePeriod,
    creatingPeriod,
}: Readonly<CreatePeriodDialogProps>): React.ReactElement {
    const {t} = useTranslation();

    return (
        <Dialog open={open} onClose={onClose} fullWidth maxWidth="xs">
            <DialogTitle>{t('payroll.period.creationTitle')}</DialogTitle>
            <DialogContent>
                <Box sx={{color: "text.secondary", mb: 2, fontSize: "0.875rem", textAlign: "left"}}>
                    {t('payroll.period.creationDescription')}
                </Box>
                <Box sx={{display: "flex", flexDirection: "column", gap: 2}}>
                    <FormControl fullWidth>
                        <InputLabel id="create-period-month-label">{t('payroll.period.selectMonth')}</InputLabel>
                        <Select
                            labelId="create-period-month-label"
                            value={selectedMonth}
                            label={t('payroll.period.selectMonth')}
                            onChange={handleMonthChange}
                        >
                            {months.map((month) => (
                                <MenuItem key={month.value} value={month.value}>{month.label}</MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                    <FormControl fullWidth>
                        <InputLabel id="create-period-year-label">{t('payroll.period.selectYear')}</InputLabel>
                        <Select
                            labelId="create-period-year-label"
                            value={selectedYear}
                            label={t('payroll.period.selectYear')}
                            onChange={handleYearChange}
                        >
                            {years.map((year) => (
                                <MenuItem key={year} value={year}>{year}</MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Box>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} disabled={creatingPeriod}>
                    {t('common.actions.cancel')}
                </Button>
                <Button
                    variant="contained"
                    onClick={async () => {
                        await handleCreatePeriod();
                        onClose();
                    }}
                    disabled={creatingPeriod}
                >
                    {creatingPeriod ? t('payroll.period.creating') : t('payroll.period.createButton')}
                </Button>
            </DialogActions>
        </Dialog>
    );
}
